export default "__VITE_ASSET__DFMzpwKv__"